var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiIntegrationDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v512h512v-512zm482 120h-452v-30h232.213l60-60h159.787zm-202.213-90-30 30h-219.787v-30zm-249.787 452v-332h452v332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.333 407h30v-46h50.667v46h30v-182h-110.667zm80.667-152v76h-50.667v-76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.667 225h30v182h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 407h30v-46h80.667v-136h-110.667zm30-152h50.667v76h-50.667z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIntegrationDocs);
export default __webpack_public_path__ + "static/media/api_integration_docs.4b178e56333c129b6b24b3f7c664af6e.svg";
export { ForwardRef as ReactComponent };